<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>
<router-outlet></router-outlet>
<wsd-global-messages [life]="4000"></wsd-global-messages>
